import {Inject, Injectable} from '@angular/core';
import {Observable, from, throwError} from 'rxjs';
import {catchError, map} from 'rxjs/operators';
import {CommonRzmService} from 'common-domain';
import {AuthService} from 'common-domain';
import {HttpClient} from '@angular/common/http';
import {Delegation} from '@iana-rzms/bff-sdk';
import {BffClientService} from 'common-domain';

@Injectable({
  providedIn: 'root'
})
export class NewdelegationService extends CommonRzmService {

  constructor(
    @Inject(HttpClient) http,
    @Inject('env') environment,
    @Inject(AuthService) auth,
    @Inject(BffClientService) bffClientService: BffClientService
  ) {
    super(http, environment, auth, bffClientService);
  }

  startProcess(newgtld: string, token: string): Observable<any> {
    return from(Delegation.initiateNewDelegation(
      this.bffClientService.withDefaults({
        body: {
          tld: newgtld,
          token: token
        }
      })
    ).catch(error => {
      throw error;
    })).pipe(
      map(response => {
        if (response && response.error) {
          throw response.error;
        }
        return response;
      }),
      catchError(error => {
        return throwError(() => error);
      })
    );
  }
}
